<app-header-configuration
  [title]="'P00043.installation.paramHorloge' | translate"
  [description]="'P00043.installation.paramHorloge.description' | translate"
>
</app-header-configuration>

<app-two-choices-control
  [title]="'P00043.installation.horloge' | translate"
  [firstLabel]="
    'P00039.lighting.functionality.parameters.setting.title.clock.day'
      | translate
  "
  [firstValue]="0"
  [secondLabel]="
    'P00039.lighting.functionality.parameters.setting.title.clock.week'
      | translate
  "
  [secondValue]="1"
  [value]="actionStack!.getValue('paPTypeHorloge')"
  (onChange)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PAC_Parametrage,
      'paPTypeHorloge',
      $event
    );
    this.actionStack!.commit()
  "
>
</app-two-choices-control>

@if (this.actionStack!.getValue('paPTypeHorloge') === 0) {
  <app-larged-link
    [name]="
      'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
        | translate
    "
    (onPress)="goToFunctionParametersSettingsClockScreen()"
  >
  </app-larged-link>
} @else {
  <app-larged-link
    [name]="
      'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
        | translate
    "
    (onPress)="goToFunctionParametersSettingClockWeekScreen()"
  >
  </app-larged-link>
}

<app-label-description
  [description]="'P00043.installation.horloge.description' | translate"
></app-label-description>

<app-label-configuration
  [title]="'P00043.installation.regulation.mode' | translate"
  [titleListe]="'P00043.installation.regulation.mode.value' | translate"
  [value]="actionStack!.getValue('paPModeRegulation')"
  [liste]="P00043ModeRegulation"
  (onPress)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PAC_Parametrage2,
      'paPModeRegulation',
      $event
    );
    this.actionStack!.commit()
  "
>
</app-label-configuration>

<app-switch-configuration
  [title]="
    'P00043.installation.paraminstallation.comportementFiltration.title'
      | translate
  "
  [nameCustom]="
    'P00043.installation.paraminstallation.comportementFiltration.value'
      | translate
  "
  [value]="actionStack!.getValue('paIActivationPrioritePAC') !== 0"
  [description]="
    'P00043.installation.paraminstallation.comportementFiltration.description'
      | translate
  "
  (onPress)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PAC_Installation,
      'paIActivationPrioritePAC',
      $event ? 1 : 0
    );
    this.actionStack!.commit()
  "
>
</app-switch-configuration>

<app-switch-configuration
  [title]="
    'P00043.installation.paraminstallation.autoMaintienFiltration.title'
      | translate
  "
  [nameCustom]="
    'P00043.installation.paraminstallation.autoMaintienFiltration.value'
      | translate
  "
  [value]="actionStack!.getValue('paIActivationAutoMaintien') !== 0"
  [description]="
    'P00043.installation.paraminstallation.autoMaintienFiltration.description'
      | translate
  "
  (onPress)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PAC_Installation,
      'paIActivationAutoMaintien',
      $event ? 1 : 0
    );
    this.actionStack!.commit()
  "
>
</app-switch-configuration>
